import { render, staticRenderFns } from "./ElProcSy.vue?vue&type=template&id=2e930cf0&"
import script from "./ElProcSy.vue?vue&type=script&lang=js&"
export * from "./ElProcSy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports